import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';

/**
 * Update a statement's free-text note (LR-556). Only `notes` travels; the
 * backend endpoint ignores any other field. Invalidate the statements branch:
 * the `statements()` prefix covers both the list and document keys, so the list
 * tooltip and the document view (LR-557, where the note editor now lives) both
 * pick up the new note.
 *
 * Invalidate-only, no optimistic cache patch: NotesEditor holds the typed draft
 * until the refetched savedNotes catches up (its `touched` flag), so there is no
 * flash of the old note to guard against here (the LR-556 setQueryData patch of
 * the detail cache went away with the detail modal in LR-557).
 */
export const useUpdateNotes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, notes }: { id: number; notes: string }) =>
      billingService.updateNotes(id, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.statements() });
    },
  });
};
